export const update = {
  form: {
    name: '水洗機表記名',
    typeName: '水洗機種類',
    washingInfo: '水洗機情報',
    tankInfo: '使用洗剤タンク',
    tankNo: '洗剤 No.',
    update: '保存',
    cancel: 'キャンセル',
    select: 'セレクト',
    requireName: '水洗機表記名を入力してください',
    requireTypeName: '水洗機種類を入力してください',
  },
  pageHeader: {
    title: '水洗機リスト　水洗機情報編集画面',
    back: '戻る',
  },
}
